<app-overview [query]="query" (dataChange)="data = $event" [windowScroll]="true">
    <div class="header-bar align-items-center row mb-4">
        <div class="col">
            <app-filter [(filterTerm)]="term" (onUpdate)="executeQuery()" placeholder="Search"></app-filter>
        </div>
        <div *ngIf="appContext.isAdminOrIntermediary()" class="col-auto ms-auto d-flex flex-row align-items-center">
            <button class="btn btn-primary" (click)="linkContract()">
                <i class="bi bi-link-45deg me-1"></i>
                <span class="d-none d-lg-inline">Link contract</span>
            </button>
        </div>
    </div>
    <div class="overview-items pb-4">
        <div class="row mx-0">
            <ng-container *ngFor="let record of data; trackBy: trackByForRecord">
                <div class="col-xl-4 col-md-6 col-12">
                    <ng-container *ngIf="record.entity.connection; else organisationTemplate">
                        <app-linked-contract-connection-overview-item [linkedContract]="record"></app-linked-contract-connection-overview-item>
                    </ng-container>
                    <ng-template #organisationTemplate>
                        <app-linked-contract-overview-item [linkedContract]="record"></app-linked-contract-overview-item>
                    </ng-template>
                </div>
            </ng-container>
        </div>
    </div>
    <div class="empty-container col-12 h-100 d-flex align-items-center justify-content-center flex-column">
        <span class="h1 mb-2">No linked contracts found</span>
        <span class="text-secondary">Try adjusting your filters or search term</span>
    </div>
</app-overview>
